import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Colors } from 'src/app/shared/enums/colors';

@Component({
  selector: 'app-status-infobox',
  templateUrl: './status-infobox.component.html',
  styleUrls: ['./status-infobox.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StatusInfoboxComponent {
  @Input() text:string;
  @Input() color:string = Colors.LIME;
  @Input() isActive:boolean=false;
  @Input() amount:string;
}
